import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=67767a0c&scoped=true&"
import script from "./EditDocument.vue?vue&type=script&lang=js&"
export * from "./EditDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67767a0c",
  null
  
)

export default component.exports